import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const EclipseShortcuts = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Essential Eclipse Shortcuts: Speed Up Your Development</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>
          
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/eclipse_shortcuts.png" alt="Eclipse Shortcuts" fluid />
            </Col>
          </Row><br/>
          
          <h4>Introduction</h4>
          <p className="mt-4 blacktext">
            Eclipse is one of the most popular integrated development environments (IDE) for Java developers. While it offers a range of powerful features, knowing the right shortcut keys can significantly enhance your efficiency. Whether you are a beginner or an experienced developer, using these shortcuts will save you time and make coding smoother. Let’s explore the most essential Eclipse shortcut keys you should master.
          </p>
          
          <h4>Basic Editing Shortcuts</h4>
          <ul>
            <li class="bgli"><strong>Ctrl + Space</strong> – Auto-complete suggestions (Content Assist)</li>
            <li class="bgli"><strong>Ctrl + D</strong> – Delete current line</li>
            <li class="bgli"><strong>Ctrl + Shift + L</strong> – Show all available shortcuts</li>
            <li class="bgli"><strong>Ctrl + /</strong> – Toggle single-line comment</li>
            <li class="bgli"><strong>Ctrl + Shift + /</strong> – Add block comment</li>
            <li class="bgli"><strong>Ctrl + Shift + \</strong> – Remove block comment</li>
            <li class="bgli"><strong>Ctrl + Z</strong> – Undo</li>
            <li class="bgli"><strong>Ctrl + Y</strong> – Redo</li>
          </ul>
          
          <h4>Navigation Shortcuts</h4>
          <ul>
          <li class="bgli"><strong>Ctrl + O</strong> – Quick outline view</li>
          <li class="bgli"><strong>Ctrl + Shift + R</strong> – Open a resource (file)</li>
          <li class="bgli"><strong>Ctrl + Shift + T</strong> – Open a type (class/interface)</li>
          <li class="bgli"><strong>Ctrl + E</strong> – Switch between open editors</li>
          <li class="bgli"><strong>F3</strong> – Go to definition (Open Declaration)</li>
          <li class="bgli"><strong>Alt + Left/Right Arrow</strong> – Navigate backward/forward</li>
          <li class="bgli"><strong>Ctrl + L</strong> – Go to a specific line number</li>
          </ul>

          <h4>Code Refactoring Shortcuts</h4>
            <ul>
                <li class="bgli"><strong>Alt + Shift + R</strong> – Rename a variable, method, or class</li>
                <li class="bgli"><strong>Alt + Shift + M</strong> – Extract a method</li>
                <li class="bgli"><strong>Alt + Shift + T</strong> – Refactoring menu</li>
                <li class="bgli"><strong>Ctrl + Shift + O</strong> – Organize imports</li>
                <li class="bgli"><strong>Ctrl + 1</strong> – Quick Fix (Suggestions for errors)</li>
                <li class="bgli"><strong>Ctrl + Shift + F</strong> – Auto format code</li>
            </ul>
            
            <h4>Running & Debugging Shortcuts</h4>
            <ul>
                <li class="bgli"><strong>Ctrl + F11</strong> – Run last launched application</li>
                <li class="bgli"><strong>F11</strong> – Debug last launched application</li>
                <li class="bgli"><strong>F5</strong> – Step into method during debugging</li>
                <li class="bgli"><strong>F6</strong> – Step over</li>
                <li class="bgli"><strong>F7</strong> – Step return</li>
                <li class="bgli"><strong>F8</strong> – Resume execution</li>
                <li class="bgli"><strong>Ctrl + Shift + B</strong> – Toggle breakpoint</li>
                <li class="bgli"><strong>Ctrl + R</strong> – Run specific configuration</li>
            </ul>
            
            <h4>Search & Productivity Shortcuts</h4>
            <ul>
                <li class="bgli"><strong>Ctrl + H</strong> – Open search dialog</li>
                <li class="bgli"><strong>Ctrl + K</strong> – Find next occurrence of selected text</li>
                <li class="bgli"><strong>Ctrl + Shift + K</strong> – Find previous occurrence</li>
                <li class="bgli"><strong>Ctrl + J</strong> – Incremental search</li>
                <li class="bgli"><strong>Ctrl + Shift + P</strong> – Find matching bracket</li>
            </ul>
            
            <h4>Window & View Management Shortcuts</h4>
            <ul>
                <li class="bgli"><strong>Ctrl + M</strong> – Maximize/minimize editor window</li>
                <li class="bgli"><strong>Ctrl + Shift + F4</strong> – Close all open editors</li>
                <li class="bgli"><strong>Ctrl + W</strong> – Close current editor</li>
                <li class="bgli"><strong>Ctrl + Shift + T</strong> – Open Type (Class)</li>
            </ul>
          
          <h4>Conclusion</h4>
          <p className="mt-4 blacktext">
            Eclipse is a powerful IDE, but its true potential is unlocked with the right plugins. Whether you're working on Java, Spring Boot, version control, or containerized applications, these plugins can significantly improve your workflow and productivity. Explore these plugins, and make the most out of your Eclipse experience!
          </p>
        </Col>

        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Posts</h4>
            <RecentPost />
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comments</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default EclipseShortcuts;
